/** Texto livre do módulo Locações: nomes, descrições e observações em maiúsculas. */
export function upperLocacaoText(value: string): string {
  return value.toLocaleUpperCase("pt-BR");
}
